import { formatCandidatRef } from 'src/utils/FormatCandidatRef'
import { applicantsList } from '../../utils/GetApplicantsListOrFalse'

export const ApplicantNameOrUndefined = (
  applicants: applicantsList[] | undefined,
  currentApplicantId?: string
): string | undefined => {
  if (applicants) {
    const find = applicants.find((el) => el.id === currentApplicantId)
    if (find) {
      return find.first_name ? `${find.first_name}` : formatCandidatRef(find)
    }
  }
  return undefined
}
